import { useParams } from 'react-router';
import FilteredGrid from '../components/FilteredGrid';
import { projects } from '../assets/projects';

const LocationPage = () => {
  const { location } = useParams();
  const formattedLocation = decodeURIComponent(location).replace(/-/g, ' ');

  const locationProducts = projects.filter(product => product.location.toLowerCase() === formattedLocation.toLowerCase());


  return (
    <>
    <title>Zuri Lands Investment Limited - Plots</title>
    <div className="banner">
          <h2>Properties in {formattedLocation}</h2>
        </div>
    <div className="location-page">
      <FilteredGrid products={locationProducts} />
    </div>
    </>
  );
};

export default LocationPage;